import { invokeUpdateResourceAllocationForRequestsAggregateCache } from '~/modules/resourcing/enhancers/updateAllocationTotalsCache';
import { useUpdateResourceAllocationInternal } from '~/modules/resourcing/hooks/useUpdateResourceAllocation';
import useResourcingChartToolbarContext from './useResourcingChartToolbarContext';

export const useUpdateResourceAllocationForRequest = () => {
  const { isResourceActualModeEnabled } = useResourcingChartToolbarContext();

  return useUpdateResourceAllocationInternal({
    isResourceActualModeEnabled,
    refetchQuery: [],
    invokeUpdateFunction: invokeUpdateResourceAllocationForRequestsAggregateCache
  });
};
